/**
 * Masque une partie de l'adresse email en gardant visible le premier et dernier caractère
 * du nom d'utilisateur avant le @
 *
 * @param email - L'adresse email à masquer
 * @returns L'email masqué avec des astérisques au milieu (nombre variable selon la longueur)
 *
 * @example
 * maskEmail("elsa.davond@gmail.com") // "e*********d@gmail.com"
 * maskEmail("john@example.com") // "j**n@example.com"
 * maskEmail("ab@test.com") // "ab@test.com" (pas de masquage si ≤ 2 caractères)
 */
export const maskEmail = (email: string): string => {
  if (!email || !email.includes("@")) {
    return email
  }

  const [username, domain] = email.split("@")

  if (username.length <= 2) {
    return email
  }

  const firstChar = username[0]
  const lastChar = username[username.length - 1]
  const maskedMiddle = "*".repeat(username.length - 2)
  return `${firstChar}${maskedMiddle}${lastChar}@${domain}`
}
